exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Separator{-webkit-margin-before:0;-webkit-margin-after:0;-webkit-margin-start:0;-webkit-margin-end:0;background-color:#59dcff;height:2px;font-weight:bold;border:none;width:100%}\n", ""]);

// exports
